import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/IntroPage.css';
var ga = window.ga;

class IntroPage extends Component {
	constructor(props) {
		super(props);

	}

  componentDidMount() {
    ga('send', 'event', 'Intro Page', 'Page View');
  }

  handleClick = () => {

    // window.dispatchEvent(this.props.events.animPage1, false);
    // this.animateToAbout();
    this.props.homeToAbout()
    // window.dispatchEvent(this.props.events.hideToPage1, false);
  }

  render() {

    return (
      <div id="IntroPage" ref={(el) => this.el = el}>
      	<h1 className="stagger-in">Best-in-class digital production made ridiculously easy.</h1>

        <h2 className="stagger-in">Optimized to be the perfect digital production partner for <span>agencies</span>.</h2>

        <div className='site-btn stagger-in' onClick={this.handleClick}>LEARN MORE</div>
      </div>
    );
  }
}

export default IntroPage;



// WEBPACK FOOTER //
// ./src/scripts/containers/IntroPage.js